import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const TheftLossExcess = (props) => {
  return (
    <FormGroup controlId="theftLossExcess">
      <Col componentClass={ControlLabel} sm={5}>
        Theft Loss Excess (HKD)
      </Col>
      <Col sm={7}>
          <FormControl
            type="text"
            autoComplete="off"
            maxLength="60"
            value={props.theftLossExcess}
            onChange={props.handleChangeTheftLossExcess}
          />
      </Col>
    </FormGroup>
  )
}

TheftLossExcess.propTypes = {
  theftLossExcess: PropTypes.string,
  handleChangeTheftLossExcess: PropTypes.func
};

export default TheftLossExcess;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/theftLossExcess/TheftLossExcess.js